const defaultState = () => ({
  participant: null,
  meeting: null,
  messages: [],
});

const getters = {
  getSosMessages: (state) => state.messages,
};

const actions = {
  addMessage({ commit }, message) {
    commit('ADD_MESSAGE', message);
  },
  clearMessages({ commit }) {
    commit('CLEAR_MESSAGES');
  },
}

const mutations = {
  ADD_MESSAGE(state, item) {
    // Dedup: if this is a server echo for an optimistic message, replace it
    if (item && !item._optimistic && item.emerCallId && item.message) {
      for (var i = state.messages.length - 1; i >= Math.max(0, state.messages.length - 10); i--) {
        var existing = state.messages[i]
        if (existing._optimistic &&
            existing.emerCallId === item.emerCallId &&
            existing.message === item.message) {
          state.messages.splice(i, 1, item)
          return
        }
      }
    }
    state.messages.push(item);
  },
  CLEAR_MESSAGES(state) {
    state.messages = [];
  },
}

export default {
  namespaced: true,
  state() {
    return defaultState();
  },
  getters,
  actions,
  mutations,
};
